import { MobileProjectEditor } from './MobileProjectEditor';
import { withMobileProjectEditor } from './withMobileProjectEditor';

const ConnectedMobileProjectEditor = withMobileProjectEditor(
  MobileProjectEditor
);

export { ConnectedMobileProjectEditor as MobileProjectEditor };
